import { PipelineType } from '@nova/types';

import { ColourMatrixTexturePipeline, TintedTexturePipeline } from './glPipelines';
import { TexturePipelineBase } from './glPipelines/pipeline-texBase';

export type PipelineSet = { [pipelineEnumKey: string]: TexturePipelineBase };

export class TextureManipulation {
  public pipelines: PipelineSet;
  protected gl?: WebGLRenderingContext;
  protected externalContext: boolean;

  public constructor() {
    this.externalContext = false;
    this.pipelines = {
      [PipelineType.textureDefault]: new TexturePipelineBase(),
      [PipelineType.tint]: new TintedTexturePipeline(),
      [PipelineType.colourMatrix]: new ColourMatrixTexturePipeline()
    };
  }

  public InitPipelines(gl: WebGLRenderingContext, canvasWidth: number, canvasHeight: number): void {
    if (!gl) { throw new Error('SetGlContext required gl to be defined.'); }
    this.gl = gl;
    this.externalContext = true;

    for (const key in this.pipelines) {
      if (!Object.prototype.hasOwnProperty.call(this.pipelines, key)) { continue; }
      // console.log(`=== Init pipeline <${key}> ===`);
      this.pipelines[key].Init(canvasWidth, canvasHeight, gl);
    }
  }

  public ResizeCanvas(width: number, height: number) {
    for (const key in this.pipelines) {
      if (!Object.prototype.hasOwnProperty.call(this.pipelines, key)) { continue; }
      this.pipelines[key].SetDimensions(width, height);
    }
  }

  public CreateBaseTexture(imgData: ImageData): void {
    this.pipelines[PipelineType.textureDefault].CreateTextures([imgData]);
  }

  public ClearForReuse(): void {
    // ? Since it's technically the same canvas, I think only one of these should be necessary...?
    for (const key in this.pipelines) {
      if (!Object.prototype.hasOwnProperty.call(this.pipelines, key)) { continue; }
      this.pipelines[key].CleanGlState();
    }
  }

  public GetPixelData(pipelineType: PipelineType): Uint8Array {
    return this.pipelines[pipelineType].GetDrawnPixelData();
  }

  public Destroy(): void {
    for (const key in this.pipelines) {
      if (!Object.prototype.hasOwnProperty.call(this.pipelines, key)) { continue; }
      this.pipelines[key].Destroy();
    }

    if (!this.externalContext) {
      this.gl?.getExtension('WEBGL_lose_context')?.loseContext();
    }
    this.gl = undefined;
    this.pipelines = {};
  }
}
